import script from "./AboutWePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutWePage.vue?vue&type=script&setup=true&lang=js"

import "./AboutWePage.vue?vue&type=style&index=0&id=3bb5e781&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb5e781"]])

export default __exports__